import { supabase } from '../supabaseClient';

/* Accès aux données « jira_sync_health ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchJiraSyncHealth() {
  return supabase.from('jira_sync_health').select('*').eq('id', 'v1').single();
}
